import { selectChangeMessageForAgeRange } from '@UI/aside/asideAgeRange/asideAgeRangeSelectors';
import { selectChangeMessageForLinks } from '@UI/aside/asideLinks/asideLinksSelectors';
import { selectChangeMessageForSources } from '@UI/aside/asideSources/asideSourcesSelectors';
import { selectChangeMessageForZillIllustrations } from '@UI/aside/asideZillIllustrations/asideZillIllustrationsSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import {
  selectIsAgeRangeNotEmpty,
  selectIsStartageLowerThanEndage,
} from '@newStore/validation/validationRules/ageRangeValid';
import { loadIllustrationsReferencingPracticalExamples } from '@newStore/zill/zillSagas';
import { NodeType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { imageComponentBase } from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { settings } from '../../settings';

const PRACTICAL_EXAMPLE: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  information: {
    definiteArticle: true,
    single: 'Zill-praktijkvoorbeeld',
    plural: 'Zill-praktijkvoorbeelden',
    icon: require('../../../../img/icons/practicalExample.svg'),
    category: 'ZILL',
  },
  websiteHref: null,
  onLoadActions: [loadIllustrationsReferencingPracticalExamples()],
  relationsToIgnore: ['IS_VERSION_OF', 'IS_INCLUDED_IN', 'REPLACES', 'REFERENCES'],
  createModal: {
    authors: {
      addUser: true,
    },
  },
  tocTypes: [NodeType.SECTION],
  buildingBlocks: [
    { type: NodeType.SECTION },
    { type: NodeType.PARAGRAPH },
    { type: NodeType.IMAGE },
    { type: NodeType.IMAGE_GROUP },
    { type: NodeType.ATTACHMENTS_GROUP },
    { type: NodeType.MUSIC },
    { type: NodeType.VIDEO },
    { type: NodeType.VIDEO_GROUP },
    { type: NodeType.QUOTE },
    { type: NodeType.WORD_IMPORT },
  ],
  edit: [
    titleComponent,
    descriptionComponent,
    publishComponent,
    authorsComponent,
    {
      component: 'ageRange',
      reactComponent: 'AsideAgeRange',
      label: 'Leeftijd',
      asideChangeMessageSelector: selectChangeMessageForAgeRange,
      properties: ['startage', 'endage'],
      validations: [selectIsAgeRangeNotEmpty, selectIsStartageLowerThanEndage],
    },
    {
      ...imageComponentBase,
      label: 'Miniatuur',
      options: {
        type: 'THUMBNAIL',
      },
    },
    {
      component: 'linkGroup',
      reactComponent: 'AsideLinks',
      asideChangeMessageSelector: selectChangeMessageForLinks,
      // component does not work? Should this be the LinkGroup component same as pro?
      label: 'Links',
    },
    {
      component: 'zillIllustrations',
      reactComponent: 'AsideZillIllustrations',
      label: 'Illustraties',
      asideChangeMessageSelector: selectChangeMessageForZillIllustrations,
    },
    {
      component: 'sources',
      label: 'Bronnen',
      reactComponent: 'AsideSources',
      hiddenChildren: {
        containerType: ContentType.STRUCTURED_DOCUMENT,
        items: [
          {
            type: ContentType.SOURCE,
            label: 'bron',
          },
        ],
      },
      asideChangeMessageSelector: selectChangeMessageForSources,
    },
  ],
  allowSuggestions: false,
  isCreatable: true,
  isSearchable: true,
  isImportable: false,
  previewModes: [
    {
      type: 'ZILL',
      name: 'Zill Leerplansite',
      location: `${settings.apisAndUrls.zill}/#!/bib/{%key}?preview&version={%version}`,
    },
  ],
};

export default PRACTICAL_EXAMPLE;
